
import { Get, Patch, Post, Delete } from 'utils/axios';
import { localStorageUtil } from "utils/util";

/** 
 * @desc 查询基本资料
 * @param {object} param 
 */
export function reqGetInformation(params) {
  let url = `/api/v1/student/information`;
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/** 
 * @desc 修改基本资料
 * @param {object} param 
 */
export function reqUpdateInformation(params) {

  let url = '/api/v1/student/information/update';
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/** 
 * @desc 查看教材信息
 * @param {object} param 
 */
export function reqGetSubjectList(params) {
  
  let url = '/api/v1/student/subject';
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
}

/** 
 * @desc 修改教材版本
 * @param {object} param 
 */
export function reqUpdateSubject(params) {
  let url = '/api/v1/student/edition';
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
  return new Promise((resolve, reject) => {
    let obj = {
      "code": 0,
      "message": "success",
      "serverTimestamp": 1594273436973,
      "data": {
        "studentId": 169,
        "subjectId": 5,
        "editionId": 3
      }
    };
    setTimeout(() => {
      resolve(obj);
    }, 300);
  });
}

/** 
 * @desc 修改个人密码
 * @param {object} param 
 */
export function reqUpdatePassword(params) {

  let url = '/api/v1/student/updatePassword';
  return Post(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
  return new Promise((resolve, reject) => {
    let obj = {
      "code": 0,
      "message": "success",
      "serverTimestamp": 1594274830482,
      "data": null
    };
    setTimeout(() => {
      resolve(obj);
    }, 300);
  });
}

/** 
 * @desc 查看我的收藏
 * @param {object} param 
 */
export function reqGetCollectList(params) {
  let url = '/api/v1/student/collect';
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
  return new Promise((resolve, reject) => {
    let obj = {
      "code": 0,
      "message": "success",
      "serverTimestamp": 1594276440166,
      "data": {
        "pageNum": 1,
        "pageSize": 10,
        "totalCount": 3,
        "datas": [
          {
            "coverUrl": "http://mvr-resource.viewshare.net/images/videos/100370/叶片的生长变化_封面_m.jpg",
            "duration": 74,
            "resourceId": 100021,
            "fileSize": 35847143,
            "description": "农民生活影像资料",
            "createdTime": 1581144318000,
            "trailType": 2,
            "title": "农民生活影像资料",
            "type": 1,
            "params": "{\"size\":35847143,\"bitrate\":3825,\"resolution\":\"1920x1080\",\"fps\":25,\"audioRate\":48000}",
            "resourceType": 1
          },
          {
            "resourceId": 100020,
            "description": "内蒙古风土人情",
            "trailType": 2,
            "title": "内蒙古风土人情",
            "type": 1,
            "params": "{\"size\":245648039,\"bitrate\":10325,\"resolution\":\"1920x1080\",\"fps\":25,\"audioRate\":48000}",
            "coverUrl": "http://mvr-resource.viewshare.net/images/videos/100636/茶叶会溶解吗_封面_m.jpg",
            "duration": 190,
            "playCount": 100,
            "fileSize": 245648039,
            "createdTime": 1586848892000,
            "resourceType": 1
          },
          {
            "coverUrl": "http://mvr-resource.viewshare.net/images/videos/100991/太阳系_封面_m.jpg",
            "duration": 186,
            "resourceId": 100022,
            "fileSize": 88671727,
            "description": "冬季捕鱼",
            "createdTime": 1579859325000,
            "trailType": 2,
            "title": "冬季捕鱼",
            "type": 1,
            "params": "{\"size\":88671727,\"bitrate\":3807,\"resolution\":\"1920x1080\",\"fps\":25,\"audioRate\":48000}",
            "resourceType": 1
          }
        ]
      }
    };
    setTimeout(() => {
      resolve(obj);
    }, 300);
  });
}


/** 
 * @desc 查看浏览记录
 * @param {object} param 
 */
export function reqGetHistoryPlay(params) {
  let url = '/api/v1/student/play';
  return Get(url, params)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(error => {
      return Promise.reject(error)
    })
  return new Promise((resolve, reject) => {
    let obj = {
      "code": 0,
      "message": "success",
      "serverTimestamp": 1594277409073,
      "data": {
        "pageNum": 1,
        "pageSize": 10,
        "totalCount": 2,
        "datas": [
          {
            "resourceId": 100020,
            "description": "内蒙古风土人情",
            "trailType": 2,
            "title": "内蒙古风土人情",
            "params": "{\"size\":245648039,\"bitrate\":10325,\"resolution\":\"1920x1080\",\"fps\":25,\"audioRate\":48000}",
            "coverUrl": "http://mvr-resource.viewshare.net/0-内蒙古风土人情_封面_s.jpg",
            "duration": 190,
            "playCount": 100,
            "fileSize": 245648039,
            "createdTime": 1586848892000,
            "subType": 1,
            "resourceType": 1
          },
          {
            "coverUrl": "http://mvr-resource.viewshare.net/0-农民生活影像资料_封面_s.jpg",
            "duration": 74,
            "resourceId": 100021,
            "fileSize": 35847143,
            "description": "农民生活影像资料",
            "createdTime": 1581144318000,
            "subType": 1,
            "trailType": 2,
            "title": "农民生活影像资料",
            "params": "{\"size\":35847143,\"bitrate\":3825,\"resolution\":\"1920x1080\",\"fps\":25,\"audioRate\":48000}",
            "channelPublished": 1,
            "resourceType": 1
          }
        ]
      }
    };
    setTimeout(() => {
      resolve(obj);
    }, 300);
  });
}